import { render, staticRenderFns } from "./RoleForm.vue?vue&type=template&id=c4e1dd48&scoped=true"
import script from "./RoleForm.vue?vue&type=script&lang=js"
export * from "./RoleForm.vue?vue&type=script&lang=js"
import style0 from "./RoleForm.vue?vue&type=style&index=0&id=c4e1dd48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e1dd48",
  null
  
)

export default component.exports